<template>
  <div class="base-input"
       :cy="`base-input-${name}`">
    <label :for="name">
      <span class="block">
        {{ label || name }}
      </span>
      <input :id="name"
             :cy="cy || name"
             :value="value"
             :type="type || 'text'"
             :placeholder="placeholder || label || name"
             @input="handleInput" />
    </label>
  </div>
</template>

<script>
  export default {
    name: "BaseInput",
    props: {
      name: String,
      cy: String,
      type: String,
      label: String,
      value: String | Number,
      placeholder: String,
    },
    methods: {
      handleInput (ev) {
        this.$emit('input', {
          name: this.name,
          value: ev.target.value
        })
      }
    }
  }
</script>

<style lang="less">
  .base-input {
    @media only screen and (min-width: 0) {

    }
  }
</style>
